import React from 'react';
import { MessageCircle } from 'lucide-react';

const WhatsAppButton = () => (
  <a
    href="https://wa.me/491725498156?text=Hey%20Sven%2C%20ich%20interessiere%20mich%20f%C3%BCr%20eure%20Produkte!"
    target="_blank"
    rel="noopener noreferrer"
    data-testid="whatsapp-float-btn"
    style={{
      position: 'fixed',
      bottom: '1.5rem',
      right: '1.5rem',
      zIndex: 90,
      width: '56px',
      height: '56px',
      borderRadius: '50%',
      background: '#25D366',
      color: 'white',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      boxShadow: '0 4px 20px rgba(37, 211, 102, 0.4)',
      transition: 'transform 0.3s, box-shadow 0.3s',
      textDecoration: 'none',
    }}
    onMouseEnter={e => { e.currentTarget.style.transform = 'scale(1.1)'; e.currentTarget.style.boxShadow = '0 6px 30px rgba(37, 211, 102, 0.6)'; }}
    onMouseLeave={e => { e.currentTarget.style.transform = 'scale(1)'; e.currentTarget.style.boxShadow = '0 4px 20px rgba(37, 211, 102, 0.4)'; }}
  >
    <MessageCircle size={24} fill="white" />
  </a>
);

export default WhatsAppButton;
